import React, { useEffect } from "react";

import NavBarCustom from "../../components/NavBarCustom/NavBarCustom";
import Footer from "../../containers/Footer/Footer";
import Payments from "../../containers/Payments/Payments";

import "../../App.css";

import "./PaymentsPage.css";

const PaymentsPage = (props) => {
	useEffect(() => {
		// Scroll to the top when the component mounts
		window.scrollTo(0, 0);
	}, []);

	return (
		<div className="payments-page-container navbar-correction">
			<NavBarCustom />
			<Payments />
			<Footer />
		</div>
	);
};

export default PaymentsPage;
